import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import services from './services.js';
//组件
import baseInfoForm from '../../../components/agent-base-infonew';
import contactForm from '../../../components/agent-contactnew';
import agentInfo from '../../../components/agent-infonew';
import operateAddressDialog from 'operateAddressDialog';
import selectStaffDialog from 'selectStaffDialog';
import addCompany from '../addCompany'; //新增公司弹窗
import viewPhoto from 'src/common/js/viewPhoto';

export default {
    mixins: [services],
    components: {
        'base-info-form': baseInfoForm,
        'contact-form': contactForm,
        'agent-info': agentInfo,
        operateAddressDialog,
        selectStaffDialog,
        addCompany
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            baseInfo: null,
            contact: null,
            id: 0,
            title: '',
            form: this.getFormData(),
            dialogObj: '', //判断是招商还是业务经理
            isRequired: false, //判断必填字段
            isPerson: true, //判断个人
            Companys: []
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    watch: {

    },
    methods: {
        getFormData() {
            return cloneDeep({
                Id: '',
                Industry_Id: 9,
                Contact: {},
                Customer: {}
            });
        },
        show(options) {
            this.dialogVisible = true
            this.title = options.title

            this.id = 0
            this.$nextTick(() => {
                this.form = this.getFormData()
                this.$refs.baseInfo.resetFields();
                this.$refs.contactAfter.resetFields();
            })
            if (options.Id) {
                this.id = options.Id
                // 修改审核获取单条
                this.GetById()
                this.form.Id = this.id


            }

        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "xxx", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: "xxx"
                }]
            });
        },
        changeAgentType(val) {
            if (val == 14) {
                // 公司
                this.refContact = 'contactAfter'
                this.isRequired = true
                this.isPerson = false
            } else {
                // 个人
                this.isPerson = true
                this.refContact = 'contactBefore'
                this.isRequired = false
            }
        },
        showSelectStaffDialog(val) {
            this.dialogObj = val
            this.$refs.refSelectStaffDialog.show();
        },
        //选择员工
        selectedStaff(item) {
            if (item !== undefined) {
                if (this.dialogObj == 'Manager') {
                    // 招商经理信息
                    this.$refs.baseInfo.setStaffInfo2(item);
                } else {
                    this.$refs.baseInfo.setStaffInfo(item);
                }
            }


        },
        // 新增公司
        addCompany() {
            this.$refs.addCompany.show({
                title: "新增公司信息",
                Id: this.id,
                BusEmployeeName: this.baseInfo.BusEmployeeName,
                BusEmployeeId: this.baseInfo.BusEmployeeId,
                LeasingManagerName: this.baseInfo.LeasingManagerName,
                LeasingManagerId: this.baseInfo.LeasingManagerId


            })
        },
        //关闭弹窗
        close() {
            this.dialogVisible = false;
        },

        submit() {
            this.$nextTick(() => {
                // 新增 修改提交
                let baseInfo = this.$refs.baseInfo.validate(); //联系人信息
                let contact = false
                if (!!baseInfo) {
                    contact = this.$refs.contactAfter.validate(); //公司基本信息
                }
                if (!!baseInfo && !!contact) {
                    this.form.Contact = cloneDeep(contact)
                    this.form.Customer = cloneDeep(baseInfo)
                    this.AgentModify(this.form)
                }
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/edit-dialog/vm.js